import React, { useState } from "react";
import Header from "./Header";
import Footer from "./Footer";
import SideNav from "./SideNav";

const CommonWrapper = (props) => {
  const [toggle, setToggle] = useState(false);
  return (
    <div className="container-fluid position-relative d-flex p-0">
      <SideNav toggle={toggle} setToggle={setToggle} />
      <div className="content">
        <Header setToggle={setToggle} />
        {props.children}
        {/*<Footer />*/}
      </div>
    </div>
  );
};

export default CommonWrapper;
